<template>
  <div class="home">
    <!-- 导航条 -->
    <!-- <van-nav-bar title="智慧校园" fixed /> -->
    <!-- 轮播图 -->
    <!-- <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item v-for="item in bannerList" :key="item.imgUrl">
        <img :src="item.imgUrl" alt="">
      </van-swipe-item>
    </van-swipe> -->
      <div class="my-swipe">
        <van-image
         v-if="childrenInfo.photo"
          round
          width="6rem"
          height="7rem"
          :src="childrenInfo.photo"
        />
        <van-image
         v-else
          round
          width="6rem"
          height="6rem"
          src="/img/default-avatar.png"
        />

        <div class="child_title">当前孩子：{{ childrenInfo.name }}</div>

      </div>
    <!-- 导航 -->
    <van-grid column-num="3" icon-size="40">
      <van-grid-item
        v-for="item in navList" :key="item.imgUrl"
        :icon="item.imgUrl"
        :text="item.text"
        @click="clickTab(item)"
      />
    </van-grid>

   <van-popup v-model="showPopup" closeable position="bottom" >
    <div class="popup_box">
        <div class="popup_title">
          选择孩子
        </div>
        <div class="popup_content">
          <van-radio-group v-model="selectRadio" @change="changeRadio">

            <van-radio :name="item.student_no" v-for="item in studentList" :key="item.student_no">

              {{item.name}}
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
              </template>
            </van-radio>

          </van-radio-group>
        </div>
       
        <div class="popup_foot" @click="showPopup=false">

          取消
        </div>
    </div>
    

   </van-popup>

  </div>
</template>

<script>
import { getHomeData,getChildrenList,useLogout} from '@/api/home'
import { getInfo } from '@/utils/storage'
export default {
  name: 'HomePage',
  components: {},
  data () {
    return {
       selectRadio: '',
      activeIcon: 'https://rlfd.oss-cn-hangzhou.aliyuncs.com/wxt_school/siyuan/user-active.png',
      inactiveIcon: 'https://rlfd.oss-cn-hangzhou.aliyuncs.com/wxt_school/siyuan/user-inactive.png',
      bannerList: [],
      navList: [],
      userInfo: {},
      childrenInfo:{},
      showPopup: false,
      studentList: [],


    }
  },
  async created () {
    const isLogin = this.$store.getters.token
    console.log('isLogin', isLogin)
    if (!isLogin) {
      this.$router.push('/login')
      return
    }
    

    // 获取用户信息
    const userInfo = getInfo()
    console.log('userInfo', userInfo)
    this.userInfo = userInfo

    //获取最新孩子列表
    let student=await getChildrenList({uid:userInfo.userId})
    this.studentList=student.data
    localStorage.setItem('childrenInfo', JSON.stringify(student.data[0]))

    const response = await getHomeData(userInfo.identify)
    console.log('pageData', response)

    // this.bannerList = response.data.bannerList
    this.navList = response.data.navList
    //获取当前选择的孩子列表
    this.childrenInfo=JSON.parse(localStorage.getItem('childrenInfo'))
    this.selectRadio=this.childrenInfo.student_no
    console.log('childrenInfo', this.childrenInfo)
  },
  methods:{
    changeRadio(val){
      for(let i=0;i<this.studentList.length;i++){
        if(this.studentList[i].student_no==val){
          let childrenInfo=this.studentList[i]
          this.childrenInfo=childrenInfo
          localStorage.setItem('childrenInfo',JSON.stringify(childrenInfo))
          this.showPopup=false
        }
      }

    },

    clickTab (item) {
      console.log(item)
      if(item.text==="切换孩子"){
        this.showPopup = true
      }else if( item.text==="退出登录" ){
         this.logout()
      }else{
        this.$router.push({
          path: item.path,
        })
      }

      
    },
    logout () {
      this.$dialog.confirm({
        title: '温馨提示',
        message: '你确认要退出么'
      }).then(() => {
        const userInfo = getInfo()
        let params = {
          uid: userInfo.userId
        }
        useLogout(params).then(res => {})
        // 退出是一个动作 => 包含了两步，分别是将 user 和 cart 进行重置
        this.$store.dispatch('user/logout')
        this.$router.push('/login')
      }).catch(() => {})
    },
  }

}
</script>

<style lang="less" scoped>
// 主题 padding
.home {
  // padding-top: 100px;
  padding-bottom: 50px;
}

// 导航条样式定制
.van-nav-bar {
  z-index: 999;
  background-color: #379623;
  ::v-deep .van-nav-bar__title {
    color: #0c0c0c;
  }
}
// 分类导航部分
.my-swipe  {
  width: 100%;
  color: #fff;
  padding-top:10px;
  padding-bottom:10px;
  font-size: 20px;
  text-align: center;
  background-color: #39a9ed;
}
.child_title{
  font-size: 18px;
}
.img-icon {
    height: 20px;
}
.popup_box{
  padding-top: 20px;
  padding-bottom: 20px;

}
.popup_title{
  text-align: center;
  font-size: 18px;
  color: #aaa;
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;

}
.popup_content{
  margin-top: 20px;
  text-align: center;
  padding-left: 30px;
}
::v-deep .van-radio{
 padding-top: 10px;

}
.popup_foot{
  margin-top: 20px;
  padding-top: 10px;
  font-size: 18px;
  color: #aaa;
  text-align: center;
  border-top: 1px solid #ddd;

}

</style>
 